import { create } from "zustand";

const useDetectionStore = create((set) => ({
  listDetections: [],
  setListDetections: (detections) =>
    set((state) => ({
      listDetections: typeof detections === "function"
        ? detections(state.listDetections)
        : detections,
    })),
}));

export default useDetectionStore;
